// OrganisationRegistrationForm.tsx
import React, { useCallback, useEffect, useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import moment from "moment";
import { organizationService } from "../lib/api/organization";
import { commonService } from "../lib/api/common";
//@ts-ignore
import Files from "react-files";
import { ReactFilesFile } from "../types/files";
import { isLessThanTheMB } from "../lib/utils/lessthan-max-filesize";
import { Messages } from "../lib/constants/messages";
import { Modal, Button } from "react-bootstrap";
import { routes } from "../routes/routes-names";
import { useNavigate } from "react-router-dom";
import "../assets/styles/organisation-registration.css"; // <- new CSS
import { values } from "lodash";

const OrganisationEditForm: React.FC = () => {
  const navigate = useNavigate();
  const [certificate, setCertificate] = useState<{ file?: File; error?: string } | null>(null);
  const [letter, setLetter] = useState<{ file?: File; error?: string } | null>(null);
  const [sheet, setSheet] = useState<{ file?: File; error?: string } | null>(null);
  const [showPreview, setShowPreview] = useState(false);

  const [previewFiles] = useState<{ [key: string]: string }>({});
  const [orgName, setOrgName] = useState("");
  const [orgEmail, setOrgEmail] = useState("");
  const [orgMobile, setOrgMobile] = useState("");
  const [orgStatus, setOrgStatus] = useState<null | string>(null);
  const [orgTypes, setOrgTypes] = useState<{ id: number; dropdownValue: string}[]>([]);
  const [countries, setCountries] = useState<{ id: number; dropdownValue: string}[]>([]);
  const [selectedCntry, setSelectedCntry] = useState('');
  const [states, setStates] = useState<{ id: number; dropdownValue: string}[]>([]);
  const [selectedState, setSelectedState] = useState('');
  const [cities, setCities] = useState<{ id: number; dropdownValue: string}[]>([]);
  const [selectedCiti, setSelectedCiti] = useState('');
  const [loading, setLoading] = useState(false);

  const initialValues = {
    organizationType: "",
    registrationNumber: "",
    address: "",
    city: "",
    state: "",
    country: "",
    registartionCertificate: "",
    coveringLetter: "",
    declarationSheet: "",
    bankAccountNumber: "",
    bankBranchNumber: "",
    bankIfscCode: ""
  };

  const [previewData, setPreviewData] = useState<typeof initialValues | null>(null);

  const validationSchema = Yup.object().shape({
    registartionCertificate: Yup.mixed().required("Required"),
    coveringLetter: Yup.mixed().required("Required"),
    declarationSheet: Yup.mixed().required("Required")
  });

  const getOrgDropDownDetails = useCallback(async () => {
    try {
      const { data } = await commonService.getDropDownValues({ params: { dropDownName: "organization_type" } });
      setOrgTypes(data);
    } catch (err) {
      console.error("dropDown error", err);
    }
  }, []);

  const getCntryDropDownDetails = useCallback(async () => {
    try {
      const { data } = await commonService.getDropDownValues({ params: { dropDownName: "country" } });
      setCountries(data);
    } catch (err) {
      console.error("dropDown error", err);
    }
  }, []);

  useEffect(() => {
    const orgData = localStorage.getItem("orgdata");
    if (orgData) {
      const retrievedObject = JSON.parse(orgData);
      setOrgName(retrievedObject.organizationName || "");
      setOrgEmail(retrievedObject.email || "");
      setOrgMobile(retrievedObject.contactNumber || "");
      if(retrievedObject.paymentStatus&&retrievedObject.paymentStatus!==undefined &&retrievedObject.paymentStatus!== null){
        setOrgStatus(retrievedObject.paymentStatus);
      }
    }
    getOrgDropDownDetails();
    getCntryDropDownDetails();
  }, []);

 {/*} const handlePreview = (values: typeof initialValues) => {
    setPreviewData(values);
    setShowPreview(true);
  };*/}

  const onSubmit = useCallback(
    async (values: typeof initialValues) => {
      try {
        setLoading(true);
        const orgData = localStorage.getItem("orgdata");
        if (orgData) {
          const retrievedObject = JSON.parse(orgData);
          const orgPrimaryId = retrievedObject.id;
          const organizationInfo = {
            id: orgPrimaryId,
            createdon: moment().format("YYYY-MM-DD"),
            posttime: moment().format("h:mm:ss")
          };

          const formData = new FormData();
          formData.append("organizationInfo", JSON.stringify(organizationInfo));
          if (certificate?.file) formData.append("registartionCertificate", certificate.file);
          if (letter?.file) formData.append("coveringLetter", letter.file);
          if (sheet?.file) formData.append("declarationSheet", sheet.file);

          const { success } = await organizationService.editOrganization(formData);
          if (success) {
            setLoading(false);
            Swal.fire({
              title: "Success",
              text: "Organization Updated successfully",
              icon: "success",
              confirmButtonText: "OK"
            }).then((result) => {

              if (result.isConfirmed) {
                 Swal.fire({
                    text: "You will be redirected to Login page",
                    icon: "warning",
                    confirmButtonText: "OK"
                  }).then((result) => {
                    if (result.isConfirmed) {
                        navigate(routes.index);
                    }
              });
            }});           
          }
        }
      } catch (err) {
        setLoading(false);
        Swal.fire({
          text: "Organization creation failed",
          icon: "error",
          confirmButtonText: "OK"
        });
        console.error("error in organization creation", err);
      }
    },
    [certificate, letter, sheet, previewData, navigate]
  );

  // helper to handle file selection (keeps DRY)
  const handleFileChange = (files: ReactFilesFile[], setter: any, fieldName: string, setFieldValue: any) => {
    if (!files || !files[0]) return;
    const file = files[0];
    const isLess = isLessThanTheMB(files[0].size, 0.5);
    if (isLess) {
      setter({ file });
      setFieldValue(fieldName, file.name);
    } else {
      alert(Messages.isLessThanTheMB);
    }
  };


  return (
    <div className="org-page">
      <div className="org-container">
        <div className="org-card">
          <h2 className="org-title">Update  Organisation For CPD Programmes</h2>

          
            <div className="org-form-wrap">
              <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                {({ setFieldValue, values, errors, touched }) => (
                  <Form>
                    <div className="upload-guidance">
                      <div>Please upload images / pdfs (.jpeg, .png, .pdf) only, &lt; 500 KB.</div>
                      <div>File name should not contain special characters and must be &lt; 20 characters.</div>
                    </div>

                    <div className="upload-row">
                      <div className="upload-col">
                        {values.registartionCertificate ? (
                          <div className="uploaded-box">
                            <div className="upload-name">Uploaded: {certificate?.file?.name}</div>
                            <button
                              type="button"
                              className="btn-remove"
                              onClick={() => {
                                setCertificate(null);
                                setFieldValue("registartionCertificate", "");
                              }}
                              aria-label="Remove registration certificate"
                            >
                              &times;
                            </button>
                          </div>
                        ) : (
                          <Files
                            className="files-dropzone"
                            onChange={(files: ReactFilesFile[]) => handleFileChange(files, setCertificate, "registartionCertificate", setFieldValue)}
                            accepts={["application/pdf", "image/*"]}
                            maxFiles={1}
                            clickable
                          >
                            <div className="drop-inner">
                              <i className="bi bi-file-earmark-arrow-up big-icon"></i>
                              <div>Upload registration Certificate</div>
                            </div>
                          </Files>
                        )}
                        {errors.registartionCertificate && touched.registartionCertificate && (
                          <div className="text-danger small">{errors.registartionCertificate}</div>
                        )}
                      </div>

                      <div className="upload-col">
                        {values.coveringLetter ? (
                          <div className="uploaded-box">
                            <div className="upload-name">Uploaded: {letter?.file?.name}</div>
                            <button
                              type="button"
                              className="btn-remove"
                              onClick={() => {
                                setLetter(null);
                                setFieldValue("coveringLetter", "");
                              }}
                              aria-label="Remove covering letter"
                            >
                              &times;
                            </button>
                          </div>
                        ) : (
                          <Files
                            className="files-dropzone"
                            onChange={(files: ReactFilesFile[]) => handleFileChange(files, setLetter, "coveringLetter", setFieldValue)}
                            accepts={["application/pdf", "image/*"]}
                            maxFiles={1}
                            clickable
                          >
                            <div className="drop-inner">
                              <i className="bi bi-file-earmark-arrow-up big-icon"></i>
                              <div>Upload Covering Letter</div>
                            </div>
                          </Files>
                        )}
                        {errors.coveringLetter && touched.coveringLetter && (
                          <div className="text-danger small">{errors.coveringLetter}</div>
                        )}
                      </div>

                      <div className="upload-col">
                        {values.declarationSheet ? (
                          <div className="uploaded-box">
                            <div className="upload-name">Uploaded: {sheet?.file?.name}</div>
                            <button
                              type="button"
                              className="btn-remove"
                              onClick={() => {
                                setSheet(null);
                                setFieldValue("declarationSheet", "");
                              }}
                              aria-label="Remove declaration sheet"
                            >
                              &times;
                            </button>
                          </div>
                        ) : (
                          <Files
                            className="files-dropzone"
                            onChange={(files: ReactFilesFile[]) => handleFileChange(files, setSheet, "declarationSheet", setFieldValue)}
                            accepts={["application/pdf", "image/*"]}
                            maxFiles={1}
                            clickable
                          >
                            <div className="drop-inner">
                              <i className="bi bi-file-earmark-arrow-up big-icon"></i>
                              <div>Upload declaration Sheet</div>
                            </div>
                          </Files>
                        )}
                        {errors.declarationSheet && touched.declarationSheet && (
                          <div className="text-danger small">{errors.declarationSheet}</div>
                        )}
                      </div>
                    </div>

                    <div className="form-actions">
                      <button type="submit" className="btn-submit">
                      {loading ? (
                                              <>
                                                <span
                                                  className="spinner-border spinner-border-sm me-2 "
                                                  role="status"
                                                  aria-hidden="true"
                                                ></span>
                                                Submitting in...
                                              </>
                                            ) : (
                                               "Submit"
                                            )}
                                          </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
        </div>
      </div>
    </div>
  );
};

export default OrganisationEditForm;
